
  import { Component, Vue , Prop,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:()=>{return []}}) private list:any
    private defaultimg='/image/1677658403671.png'

    @Inject() information:any
    get value(){
      // console.log(this.information,123)
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
    private pushmode(e){
      console.log(e)
      let data:any = {}
      if(e.value==1){
        data = {
          ...e,
          content:'[通知]填写公告内容，内容如果过长，手机端会自动轮播',//内容
          Id:0,
          moduleName:e.name,
        }
      }else if(e.value==2){
        data = {
          ...e,
          Id:0,
          imglist:[
            // {
            //   url:'',
            //   Id:0,
            // }
          ],
          moduleName:e.name,
        }
      }else if(e.value==3){
        data = {
          ...e,
          Id:0,
          img:'',
          width: 0,
          height: 0,
          openObj:0,
          imglist:[
            // {
            //   marX:'',//左边距
            //   marY:'',//右边距
            //   width:'',
            //   height:'',
            //   Id:'',
            // }
          ],
          moduleName:e.name,
        }
      }else if(e.value==4){
        data = {
          ...e,
          hasBlank:false,
          showtype:1,//1商品
          list:[],
          sortlist:[0,1,2],//销量 价格 新品
          sortstyle:1,//1一行一个 2一行两个
          Id:0,
          moduleName:e.name,
        }
      }else if(e.value==5){
        data = {
          ...e,
          coverimg:'',//封面图
          video:'',//视频
          Id:0,
          moduleName:e.name,
        }
      }else if(e.value==6){
        data = {
          ...e,
          moduleName:e.name,
        }
      }else if(e.value==7){
        data = {
          ...e,
          hasBlank:false,
          titleImg:'',
          titleImgWidth: 0,
          titleImgHeight: 0,
          subjectImg:'',
          subjectImgWidth: 0,
          subjectImgHeight: 0,
          startTime:'',
          endTime:'',
          link:{},
          shoplist:[],
          showStartTime:'',
          showEndTime:'',
          moduleName:e.name,
        }
      }else if(e.value==8){
        data = {
          ...e,
          hasBlank:false,
          moduleName:e.name,
          dateType: 3,
          someDayData: {}
        }
      }else if(e.value==9){
        data = {
          ...e,
          hasBlank:false,
          menuList:[
            {
              key:'',//选中的组件
              name:'定位菜单1',//名称
              startTime:'',
              endTime:'',
            },
            {
              key:'',//选中的组件
              name:'定位菜单2',//名称
              startTime:'',
              endTime:'',
            },
            {
              key:'',//选中的组件
              name:'定位菜单3',//名称
              startTime:'',
              endTime:'',
            },
          ],
          moduleName:e.name,
          underModule:[],//下方的组件
        }
      }else if(e.value==10){
        data = {
          ...e,
          hasBlank:true,
          list:[],
          moduleName:e.name,
        }
      }else if(e.value==11){
        data = {
          ...e,
          list:[],
          moduleName:e.name,
          sortstyle:1,//1一行一个 2一行两个
          showtype:1//1商品
        }
      }else if(e.value==12){
        data = {
          ...e,
          moduleName:e.name,
          title:'',
          describe:'',
          list:[],
        }
      }
      data.key = Math.random() + ''
      console.log(data)
      this.editinfo.msg = data
      this.information.push(data)
      // console.log(this.information.map(v=>v.key),'push')
      // console.log(this.information)
      this.$forceUpdate()
    }
  }
